import { useState } from 'react'
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  VStack,
} from '@ritualco/jutsu'
import { CardPage } from 'components/PageTemplates'
import { useContent } from 'lib/content/react'

export type CompanyNameProps = {
  companyName?: string
  onNext: (companyName: string) => void
}

const CompanyName = ({ companyName = '', onNext }: CompanyNameProps) => {
  const { formatMessage } = useContent()
  const [value, setValue] = useState(companyName)
  return (
    <CardPage trackingName="CompanyName">
      <VStack spacing={3} mb={9} textAlign="center">
        <Text fontSize="small" lineHeight="small">
          {formatMessage(
            { id: 'pmportal.onboarding.stepXofY' },
            { x: 2, y: 3 }
          )}
        </Text>
        <Heading
          as="h1"
          fontSize="3xlarge"
          lineHeight="3xlarge"
          whiteSpace="pre-line"
        >
          {formatMessage({ id: 'pmportal.onboarding.companyNameTitle' })}
        </Heading>
        <Text fontSize="small" lineHeight="small" color="grayscale.secondary">
          {formatMessage({ id: 'pmportal.onboarding.companyNameDescription' })}
        </Text>
      </VStack>
      <VStack spacing={32} alignItems="normal">
        <FormControl id="companyName">
          <FormLabel>
            {formatMessage({ id: 'pmportal.onboarding.companyNameLabel' })}
          </FormLabel>
          <Input
            type="text"
            placeholder={formatMessage({
              id: 'pmportal.onboarding.companyNamePlaceholder',
            })}
            value={value}
            onChange={e => setValue(e.target.value)}
          />
        </FormControl>
        <Flex justifyContent="flex-end">
          <Button size="lg" onClick={() => onNext(value)}>
            {formatMessage({ id: 'pmportal.global.actionNext' })}
          </Button>
        </Flex>
      </VStack>
    </CardPage>
  )
}

export default CompanyName
